export default __webpack_public_path__ + "static/media/xy_logo.d077750c.png";